import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Container = styled('div')(
    ({ theme: { borderRadius, colors, spacing } }) => css`
        border-radius: ${borderRadius['border-radius-1']};

        /* This is from Blueprint's button component. No method decided on how to DRY yet */
        box-shadow: 0px 0px 0.75rem rgba(50, 39, 68, 0.08),
            0px 0px 1px rgba(50, 39, 68, 0.32),
            0px ${spacing['8px']} ${spacing['16px']} -${spacing['8px']} rgba(50, 39, 68, 0.8);

        ${Button} {
            border: 1px solid ${colors['graphic-divider']};
            border-bottom: 1px solid ${colors['graphic-divider']};
            border-radius: ${borderRadius['border-radius-1']};

            &:focus {
                border-color: transparent;
            }

            &svg:first-of-type {
                border-bottom: none;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
            &:last-child {
                border-top-left-radius: 0;
                border-top-right-radius: 0;
            }
        }
    `
);

export const Button = styled('button')(
    ({ theme: { colors, focusRing } }) => css`
        position: relative;
        display: block;
        width: 2.25rem;
        height: 2.25rem;
        border: 0;
        background: ${colors.white};
        cursor: pointer;

        &:focus {
            box-shadow: ${focusRing};
            outline: 0;
            z-index: 1;
        }
    `
);
